<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="ticket">
            <rwidget-purchase-history></rwidget-purchase-history>
        </div>
    </div>
</div>
